const formatToCurrency = (value?: number | string) =>
  `$${value || 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export default formatToCurrency;
